"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _default() {
  var _tab;

  var theme = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var palette = theme.palette,
      tab = (_tab = {
    display: 'flex',
    alignItems: theme.tabAlignItems,
    justifyContent: theme.tabJustifyContent,
    borderBottom: "".concat(theme.tabBorderWidth, " ").concat(theme.tabBorderStyle, " ").concat(theme.tabBorderColor),
    transitionProperty: 'border, color',
    transitionDuration: palette.transitionDuration,
    transitionTimingFunction: palette.transitionFunction,
    paddingTop: theme.tabPaddingTop,
    paddingBottom: theme.tabPaddingBottom,
    paddingLeft: theme.tabPaddingLeft,
    paddingRight: theme.tabPaddingRight,
    color: theme.tabColor,
    fontSize: theme.tabFontSize,
    lineHeight: theme.tabLineHeight,
    fontWeight: theme.tabFontWeight,
    cursor: theme.tabCursor
  }, (0, _defineProperty2["default"])(_tab, '&:not(:last-child)', {
    marginRight: theme.tabMarginRight
  }), (0, _defineProperty2["default"])(_tab, '&:hover', {
    borderBottom: "".concat(theme.hoverTabBorderWidth, " ").concat(theme.hoverTabBorderStyle, " ").concat(theme.hoverTabBorderColor),
    fontSize: theme.hoverTabFontSize,
    lineHeight: theme.hoverTabLineHeight,
    fontWeight: theme.hoverTabFontWeight,
    cursor: theme.hoverTabCursor,
    color: theme.hoverTabColor
  }), _tab);
  return {
    root: {
      fontFamily: theme.fontFamily,
      fontSize: theme.fontSize,
      lineHeight: theme.lineHeight
    },
    tabsContainer: {
      display: 'flex',
      alignItems: theme.tabsAlignItems,
      justifyContent: theme.tabsJustifyContent,
      overflowX: 'auto'
    },
    tab: tab,
    activeTab: _objectSpread({}, tab, {
      borderBottom: "".concat(theme.activeTabBorderWidth, " ").concat(theme.activeTabBorderStyle, " ").concat(theme.activeTabBorderColor),
      fontSize: theme.activeTabFontSize,
      lineHeight: theme.activeTabLineHeight,
      fontWeight: theme.activeTabFontWeight,
      cursor: theme.activeTabCursor,
      color: theme.activeTabColor
    })
  };
}